import React, { useCallback } from 'react';
import Document from '@uber/base-icons/document';
import { useAtomValue } from 'jotai';
import { useDrawer } from '../../../common/multi-level-drawer';
import { TASK_QUESTIONNAIRE_TITLE } from '../../../modernization-common/side-panel/const';
import { useTaskQuestionnaire } from '../../../modernization-common/side-panel/hooks/use-task-questionnaire';
import { useSidePanel } from '../../../modernization-common/side-panel/side-panel-provider';
import { isVideoLabelingM4EnabledAtom } from '../atoms/m4-atoms';
const TASK_QUESTIONNAIRE_DRAWER_ID = 'image-task-questionnaire';
export const useOpenTaskQuestionnaireDrawer = () => {
  const isM4Enabled = useAtomValue(isVideoLabelingM4EnabledAtom);
  const {
    taskQuestionnaireComponent
  } = useSidePanel();
  const {
    open
  } = useDrawer();
  const {
    openTaskQuestionnaire
  } = useTaskQuestionnaire({
    taskQuestionnaireComponent
  });
  const openTaskQuestionnaireDrawer = useCallback(() => {
    if (!taskQuestionnaireComponent) return;

    // Non-M4 renders task questionnaire through the v1 StatefulSideDrawer, matching
    // every other non-M4 entry point (e.g. label-panel.tsx). M4 has no StatefulSideDrawer
    // mounted, so it uses the v2 multi-level drawer stack instead.
    if (!isM4Enabled) {
      openTaskQuestionnaire();
      return;
    }

    // Do not pass `close` as this drawer's `onClose` — the Drawer header's close button
    // already calls `close()` to pop this drawer off the stack, and closeDrawerAtom also
    // invokes the popped drawer's own `onClose` afterwards. Wiring `onClose: close` here
    // would pop a second time, dropping whatever drawer (e.g. Remaining Items) sits
    // underneath instead of revealing it.
    open({
      id: TASK_QUESTIONNAIRE_DRAWER_ID,
      title: TASK_QUESTIONNAIRE_TITLE,
      titleStartEnhancer: <Document size={16} />,
      content: ({
        onClose
      }) => taskQuestionnaireComponent.Component?.({
        onClose
      }),
      styleOverrides: {
        content: {
          padding: '0px'
        }
      }
    });
  }, [isM4Enabled, taskQuestionnaireComponent, openTaskQuestionnaire, open]);
  return {
    openTaskQuestionnaireDrawer
  };
};